module.exports = __webpack_public_path__ + "static/media/0005_Medium.efa4fc24.jpg";